/** 引数は 401 になったリクエストが送ったトークン。 */
type Listener = (token: string) => void;

let listener: Listener | null = null;

/** AuthProvider が登録する。API クライアントの 401(セッション切れ)通知の宛先。 */
export const setUnauthorizedListener = (next: Listener | null): void => {
  listener = next;
};

export const notifyUnauthorized = (token: string): void => {
  listener?.(token);
};
